export default "__VITE_ASSET__DJOSP55h__"